import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("mask", {
  id: "path-1-inside-1_11454_17539",
  fill: "white"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85787 16.5 1.5 13.1421 1.5 9C1.5 4.85787 4.85786 1.5 9 1.5Z" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", {
  "clip-path": "url(#paint0_angular_11454_17539_clip_path)",
  "data-figma-skip-parse": "true",
  mask: "url(#path-1-inside-1_11454_17539)"
}, [
  /*#__PURE__*/_createElementVNode("g", { transform: "matrix(0.0075 -3.27835e-10 3.27835e-10 0.0075 9 9)" }, [
    /*#__PURE__*/_createElementVNode("foreignObject", {
      x: "-1300",
      y: "-1300",
      width: "2600",
      height: "2600"
    }, [
      /*#__PURE__*/_createElementVNode("div", {
        xmlns: "http://www.w3.org/1999/xhtml",
        style: {"background":"conic-gradient(from 90deg,rgba(65, 71, 81, 1) 0deg,rgba(255, 255, 255, 1) 360deg)","height":"100%","width":"100%","opacity":"1"}
      })
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9 1.5L9 3.75C11.8995 3.75 14.25 6.10051 14.25 9L16.5 9L18.75 9C18.75 3.61522 14.3848 -0.75 9 -0.75L9 1.5ZM16.5 9L14.25 9C14.25 11.8995 11.8995 14.25 9 14.25L9 16.5L9 18.75C14.3848 18.75 18.75 14.3848 18.75 9L16.5 9ZM9 16.5L9 14.25C6.10051 14.25 3.75 11.8995 3.75 9L1.5 9L-0.75 9C-0.749999 14.3848 3.61522 18.75 9 18.75L9 16.5ZM1.5 9L3.75 9C3.75 6.10051 6.10051 3.75 9 3.75L9 1.5L9 -0.75C3.61522 -0.749999 -0.75 3.61522 -0.75 9L1.5 9Z",
  "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.25490197539329529,\"g\":0.27843138575553894,\"b\":0.31764706969261169,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.25490197539329529,\"g\":0.27843138575553894,\"b\":0.31764706969261169,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":15.0,\"m01\":6.5567081719564158e-07,\"m02\":1.5000001192092896,\"m10\":-6.5567081719564158e-07,\"m11\":15.0,\"m12\":1.5000008344650269},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
  mask: "url(#path-1-inside-1_11454_17539)"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "paint0_angular_11454_17539_clip_path" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9 1.5L9 3.75C11.8995 3.75 14.25 6.10051 14.25 9L16.5 9L18.75 9C18.75 3.61522 14.3848 -0.75 9 -0.75L9 1.5ZM16.5 9L14.25 9C14.25 11.8995 11.8995 14.25 9 14.25L9 16.5L9 18.75C14.3848 18.75 18.75 14.3848 18.75 9L16.5 9ZM9 16.5L9 14.25C6.10051 14.25 3.75 11.8995 3.75 9L1.5 9L-0.75 9C-0.749999 14.3848 3.61522 18.75 9 18.75L9 16.5ZM1.5 9L3.75 9C3.75 6.10051 6.10051 3.75 9 3.75L9 1.5L9 -0.75C3.61522 -0.749999 -0.75 3.61522 -0.75 9L1.5 9Z",
      mask: "url(#path-1-inside-1_11454_17539)"
    })
  ])
], -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }